import { useEffect, useState } from 'react';

export function useDebouncedValue<ValueType>(value: ValueType, delayMilliseconds: number): ValueType {
  const [debouncedValue, setDebouncedValue] = useState<ValueType>(value);

  useEffect(
    function scheduleDebouncedUpdate() {
      const timeoutHandle = window.setTimeout(function applyValue() {
        setDebouncedValue(value);
      }, delayMilliseconds);
      return function clearScheduledUpdate() {
        window.clearTimeout(timeoutHandle);
      };
    },
    [value, delayMilliseconds]
  );

  return debouncedValue;
}
